import type React from "react";

/**
 * Converts links with javascript: URLs into safe click handlers.
 * React blocks javascript: in href for security, so we replace it with href="#"
 * and an onClick that executes the extracted code (e.g. Osano cookie preferences).
 * Returns null for non-javascript links so they render as normal links.
 */
export function transformJavaScriptLink<
	T extends { href?: string; children?: React.ReactNode }
>(
	link: T
): (T & { href: string; onClick: (e: React.MouseEvent) => void }) | null {
	const href = link?.href;
	const prefix = "javascript:";
	if (typeof href !== "string" || !href.toLowerCase().startsWith(prefix))
		return null;

	const code = href.slice(prefix.length).trim();
	if (!code) return null;

	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault();
		try {
			new Function(code)();
		} catch (err) {
			console.error("Failed to execute link action:", err);
		}
	};

	return { ...link, href: "#", onClick: handleClick };
}
